import { connect } from 'react-redux';
import ItemProduct from './ItemProduct';

const mapStateToProps = ({ estimateBuilder }, { itemId }) => {
  const {
    itemProduct,
  } = estimateBuilder.entities.items.byId[itemId];
  return {
    itemProduct,
    itemId,
  };
};

export default connect(mapStateToProps)(ItemProduct);
